import React from "react";

interface IProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

const DeathSquadIcon: React.FC<IProps> = ({
  width = 12,
  height = 14,
  fillColor = "white",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0314 8.56285C10.9614 8.28225 10.9902 7.83191 11.0961 7.56252C11.0961 7.56252 11.4307 6.70874 11.4301 5.94701C11.4301 3.04031 9.07337 0.683594 6.16668 0.683594C3.2584 0.683594 0.903261 3.04031 0.903261 5.94701C0.902471 6.70874 1.23739 7.56252 1.23739 7.56252C1.34302 7.83191 1.37208 8.28225 1.30181 8.56285L1.09464 9.39184C0.989318 9.81282 1.18038 10.3798 1.51972 10.6513C1.51972 10.6513 1.67699 10.7773 1.86948 10.9309C2.06164 11.0847 2.43888 11.1228 2.70779 11.0153C2.70779 11.0153 2.8938 10.9407 3.12134 10.8498C3.34888 10.7588 3.65332 10.6841 3.79812 10.6841C3.94323 10.6841 4.06134 10.8019 4.06134 10.9474C4.06134 11.6676 3.86065 12.3192 3.53505 12.7901C5.15988 13.465 7.04367 13.5169 8.79846 12.7901C8.47255 12.3194 8.27201 11.6676 8.27201 10.9474C8.27201 10.8019 8.38981 10.6841 8.53524 10.6841C8.67972 10.6841 8.98447 10.7588 9.2117 10.8498C9.43876 10.9407 9.62493 11.0153 9.62493 11.0153C9.89368 11.1228 10.2711 11.0846 10.4632 10.9309C10.656 10.7773 10.8133 10.6513 10.8133 10.6513C11.1525 10.3798 11.3437 9.81282 11.2384 9.39184L11.0314 8.56285ZM5.37716 7.32093C5.37716 7.61037 5.15719 7.9347 4.88828 8.04255L3.72311 8.50884C3.18545 8.72407 2.74553 8.4261 2.74553 7.84675V6.99975C2.74553 6.41788 3.21687 5.94701 3.79827 5.94701H4.58779C5.02424 5.94701 5.37731 6.30056 5.37731 6.73653L5.37716 7.32093ZM6.51059 10.1578H5.82292C5.44458 10.1578 5.27325 9.9014 5.44253 9.58733L5.85939 8.81423C6.02851 8.50016 6.305 8.50016 6.47411 8.81423L6.89114 9.58733C7.05994 9.9014 6.88877 10.1578 6.51059 10.1578ZM9.58798 7.84675C9.58798 8.4261 9.1479 8.72423 8.6104 8.50884L7.44507 8.04255C7.17631 7.9347 6.95619 7.61037 6.95619 7.32093V6.73653C6.95619 6.30056 7.30927 5.94701 7.74572 5.94701H8.53524C9.11664 5.94701 9.58798 6.41772 9.58798 6.99975V7.84675Z"
      fill={fillColor}
    />
  </svg>
);

export default DeathSquadIcon;
